import Client from 'Classes/Client';
import Agent from 'Classes/Agent';
import Plan from 'Classes/Plan';
import { PURGE } from 'redux-persist';

export const CLIENT_AGREEMENT = 'clientAgreement';
export const FORM_PART_A = 'formPartA';
export const FORM_PART_B = 'formPartB';
export const EDIT_ACTION_ITEM_MODAL = 'editActionItemModal';
export const PRIVACY_POLICY = 'privacyPolicy';
export const DEPENDENTS_FLYOUT = 'dependentsFlyout';
export const FINANCIAL_GOALS_FLYOUT = 'financialGoalsFlyout';
export const OVERDUE_ACTION_ITEMS_FLYOUT = 'overdueActionItemsFlyout';
export const HOUSEHOLD_INFO_FLYOUT = 'householdInfoFlyout';
export const SET_USER = 'set.user';
export const SET_CLIENT = 'set.client';
export const SET_AGENT = 'set.agent';
export const SET_HOUSEHOLD_CLIENTS = 'set.household.clients';
export const SET_HOUSEHOLD_SERVICES = 'set.household.services';
export const SET_HOUSEHOLD_CHILDREN = 'set.household.children';
export const SET_PLAN = 'set.plan';
export const ADVISOR_HOVER_NAVIGATOR = 'advisor.hover.nav';
export const ADVISOR_LEAVE_NAVIGATOR = 'advisor.leave.nav';
export const ADVISOR_HOVER_SIDEBAR = 'advisor.hover.sidebar';
export const ADVISOR_LEAVE_SIDEBAR = 'advisor.leave.sidebar';
export const END_SESSION = 'end.session';
export const INCREASE_API_WAIT = 'api.wait';
export const DECREASE_API_WAIT = 'api.done';
export const REGISTER_NOTIFICATION = 'notification.register';
export const HOUSEHOLD_FLYOUT = 'householdFlyout';
export const ORDER_66 = 'order66';
export const CREATE_HOUSEHOLD_FLYOUT = 'createHouseholdFlyout';

export const setPlan = (plan = new Plan()) => ({
  type: SET_PLAN,
  plan,
});

export const setUser = (user = {}, apiKey = {}) => ({
  type: SET_USER,
  user,
  apiKey,
});

export const setClient = (client = new Client()) => ({
  type: SET_CLIENT,
  client,
});

export const setAgent = (agent = new Agent()) => ({
  type: SET_AGENT,
  agent,
});

export const setHouseholdClients = (clients = []) => ({
  type: SET_HOUSEHOLD_CLIENTS,
  clients,
});

export const setHouseholdClientServices = (clientServices = []) => ({
  type: SET_HOUSEHOLD_SERVICES,
  services: clientServices,
});

export const setHouseholdChildren = (children = []) => ({
  type: SET_HOUSEHOLD_CHILDREN,
  children,
});

export const advisorHoverNavigator = payload => ({
  type: ADVISOR_HOVER_NAVIGATOR,
  payload,
});

export const advisorLeaveNavigator = payload => ({
  type: ADVISOR_LEAVE_NAVIGATOR,
  payload,
});

export const increaseWaitCount = n => ({
  type: INCREASE_API_WAIT,
  n,
});

export const decreaseWaitCount = n => ({
  type: DECREASE_API_WAIT,
  n,
});

export const advisorHoverSidebar = () => ({
  type: ADVISOR_HOVER_SIDEBAR,
});

export const advisorLeaveSidebar = () => ({
  type: ADVISOR_LEAVE_SIDEBAR,
});

export const endSession = () => ({
  type: END_SESSION,
});

export const purge = () => ({
  type: PURGE,
  result: () => ({}),
});

export const registerNotificaton = (notification = new Notification()) => ({
  type: REGISTER_NOTIFICATION,
  notification,
});

export const displayPrivacyPolicy = () => ({
  type: PRIVACY_POLICY,
  display: true,
});

export const hidePrivacyPolicy = () => ({
  type: PRIVACY_POLICY,
  display: false,
});

export const displayClientAgreement = (householdClientID = null) => ({
  type: CLIENT_AGREEMENT,
  display: householdClientID,
});

export const hideClientAgreement = () => ({
  type: CLIENT_AGREEMENT,
  display: null,
});

export const displayFormPartA = () => ({
  type: FORM_PART_A,
  display: true,
});

export const hideFormPartA = () => ({
  type: FORM_PART_A,
  display: false,
});

export const displayFormPartB = () => ({
  type: FORM_PART_B,
  display: true,
});

export const hideFormPartB = () => ({
  type: FORM_PART_B,
  display: false,
});

export const displayEditActionItemModal = () => ({
  type: EDIT_ACTION_ITEM_MODAL,
  display: true,
});

export const hideEditActionItemModal = () => ({
  type: EDIT_ACTION_ITEM_MODAL,
  display: false,
});

export const displayFinancialGoalsFlyout = () => ({
  type: FINANCIAL_GOALS_FLYOUT,
  display: true,
});

export const hideFinancialGoalsFlyout = () => ({
  type: FINANCIAL_GOALS_FLYOUT,
  display: false,
});

export const displayDependentsFlyout = () => ({
  type: DEPENDENTS_FLYOUT,
  display: true,
});

export const hideDependentsFlyout = () => ({
  type: DEPENDENTS_FLYOUT,
  display: false,
});

export const displayHouseholdInfoFlyout = () => ({
  type: HOUSEHOLD_INFO_FLYOUT,
  display: true,
});

export const hideHouseholdInfoFlyout = () => ({
  type: HOUSEHOLD_INFO_FLYOUT,
  display: false,
});

export const displayHouseholdFlyout = id => ({
  type: HOUSEHOLD_FLYOUT,
  id,
});

export const hideHouseholdFlyout = () => ({
  type: HOUSEHOLD_FLYOUT,
  id: 0,
});

export const displayCreateHouseholdFlyout = () => ({
  type: CREATE_HOUSEHOLD_FLYOUT,
  display: true,
});

export const hideCreateHouseholdFlyout = () => ({
  type: CREATE_HOUSEHOLD_FLYOUT,
  display: false,
});

export const setOrder66Complete = () => ({
  type: ORDER_66,
  complete: true,
});

export const setOrder66Loading = () => ({
  type: ORDER_66,
  complete: false,
});
